import { Overlay } from "@angular/cdk/overlay";
import { Component } from "@angular/core";
import { ProductModel } from "../../../models/product/product.model";
import { DialogService } from "../../../services/components/dialog.service";
import { QuickViewPopUpService } from "../../../services/components/quick-view-pop-up.service";
import { ProductPopUpBaseComponent } from "../product-pop-up-base/product-pop-up-base.component";

@Component({
  selector: "pcg-ng-quick-view-pop-up",
  template: require('./quick-view-pop-up.component.html')
})
export class QuickViewPopUpComponent extends ProductPopUpBaseComponent<ProductModel> {
    public constructor(
        popupService: QuickViewPopUpService,
        overlay: Overlay,
        dialogService: DialogService
    ) {
        super(popupService, overlay, dialogService);
    }
}
